module.exports = __webpack_public_path__ + "img/yoga.9d24679e.jpg";